import { Link } from 'react-router-dom';
import AuthAwareLink from './AuthAwareLink';
import { useAuth } from '../context/AuthContext';
import { isAdminEmail } from '../lib/userLimits';
import { useIsInsideAppLayout } from './AppLayoutContext';

function Footer() {
  const isInsideAppLayout = useIsInsideAppLayout();
  const { user } = useAuth();
  const showAdminLink = isAdminEmail(user?.email);

  if (isInsideAppLayout) {
    return null;
  }

  return (
    <footer className="footer">
      <div className="footer-wrap">
        <nav className="footer-links" aria-label="Footer navigation">
          <section className="footer-link-group" aria-labelledby="footer-explore">
            <h2 id="footer-explore">Explore</h2>
            <AuthAwareLink spaPath="/features" staticPath="/features/">Features</AuthAwareLink>
            <Link to="/real-transformations">Real Transformations</Link>
            <a href="/gallery/">Gallery</a>
            <a href="/blog/">Blog</a>
          </section>

          <section className="footer-link-group" aria-labelledby="footer-resources">
            <h2 id="footer-resources">Resources</h2>
            <Link to="/room-types/living-room">Room Types</Link>
            <AuthAwareLink spaPath="/faq" staticPath="/faq/">FAQ</AuthAwareLink>
            <Link to="/sitemap">Sitemap</Link>
          </section>

          <section className="footer-link-group" aria-labelledby="footer-company">
            <h2 id="footer-company">Company</h2>
            <Link to="/">Home</Link>
            <a href="/#pricing">Pricing</a>
          </section>

          <section className="footer-link-group" aria-labelledby="footer-legal">
            <h2 id="footer-legal">Legal</h2>
            <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
            {showAdminLink ? (
              <>
                <Link to="/admin">Admin</Link>
                <Link to="/test-pages">Test Pages</Link>
              </>
            ) : null}
          </section>
        </nav>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} MyRoomsAI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
